import { setTerms } from './helpers';

export const setParkingType = setTerms('parking_type');
